import { VODCSSModules } from 'shared/utils/wix-connect';
import styles from './content-slider.styl';

@VODCSSModules(styles)
export default class ContentSlider extends React.Component {

  static propTypes = {
    className: React.PropTypes.string,
    currentPageNumber: React.PropTypes.number,
    width: React.PropTypes.number.isRequired,
    children: React.PropTypes.any,
  };

  get currentPageOffset() {
    const { currentPageNumber, width } = this.props;
    return {
      transform: `translate3d(${-1 * currentPageNumber * width}px, 0, 0)`,
    };
  }

  render() {
    const { children, className } = this.props;

    return (
      <section styleName="container"
               className={className}>
        <div styleName="content"
             data-hook="contentSliderContent"
             style={this.currentPageOffset}>
          {children}
        </div>
      </section>
    );
  }
}



// WEBPACK FOOTER //
// ./src/widget/components/content-slider/content-slider.js